import { z } from 'zod';

import { BasePType } from './base';
import { FaqItem } from './faq-item';

export const Accordion = BasePType.extend({
  type: z.enum(['accordion']),
  title: z.string().nullable().optional(),
  accordionItems: z.array(FaqItem).optional(),
});

export type Accordion = z.infer<typeof Accordion>;
